import gql from "graphql-tag";

export default gql`
	query getPlan($planCode: String!) {
		getPlanWithPrices(planCode: $planCode) {
			planID
			name
			prices {
				planCode
				subscriptionSize
				price
				betterOption
			}
		}
	}
`;

export const readPlan = ({ data }) => data && data.getPlanWithPrices;

export const readPrices = plan => plan && plan.prices;
export const packPlanCode = planCode => ({ planCode });
